import type { Header } from "@features/headers"
import type { FC } from "react"
import { Trans } from "react-i18next"

interface NewsletterHeaderPickerProps {
  header: Header | null
  headerUrl: string | null
  onOpenPicker: () => void
  onRemoveHeader: () => void
}

const NewsletterHeaderPicker: FC<NewsletterHeaderPickerProps> = ({
  header,
  headerUrl,
  onOpenPicker,
  onRemoveHeader,
}) => {
  const hasHeader = !!header || !!headerUrl

  return (
    <div className="mb-4 rounded-md border border-gray-200 bg-white p-3">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-3 flex-wrap">
          <button
            className="text-sm text-blue-600 hover:text-blue-800 underline"
            onClick={onOpenPicker}
          >
            {hasHeader ? (
              <Trans i18nKey="newsletter.header.change" />
            ) : (
              <Trans i18nKey="newsletter.header.select" />
            )}
          </button>
          {hasHeader ? (
            <span className="inline-flex items-center rounded-full bg-blue-50 px-2.5 py-0.5 text-xs font-medium text-blue-700 border border-blue-200">
              {header?.name || headerUrl}
            </span>
          ) : (
            <span className="text-xs text-gray-500">
              <Trans i18nKey="newsletter.header.noneSelected" />
            </span>
          )}
        </div>
        {hasHeader ? (
          <button
            className="text-xs text-red-600 hover:text-red-800 underline"
            onClick={onRemoveHeader}
          >
            <Trans i18nKey="newsletter.header.remove" />
          </button>
        ) : null}
      </div>
    </div>
  )
}

export default NewsletterHeaderPicker
